<script setup lang="ts">
type User = {
  label: string;
  email: string;
  password: string;
};

type Props = {
  id: number | string;
  user: User;
  active: boolean;
};

const props = defineProps<Props>();

function switchUser() {
  window.localStorage.setItem('activeUser', props.id.toString());
  window.location.reload();
}
</script>

<template>
  <div :class="['user-line', active ? 'active' : '']">
    <div class="d-flex pa-5 align-center">
      <div class="card_text px-4">
        <p class="text-secondary">{{ props.user.label }}</p>
        <p class="text-body-3">{{ props.user.email }}</p>
      </div>

      <v-spacer></v-spacer>

      <v-btn
        v-if="!active"
        @click="switchUser"
        class="switch-user_btn"
        size="small"
        variant="outlined"
        icon
        color="secondary"
      >
        <v-icon icon="fas fa-eye" />
      </v-btn>
      <v-btn v-else class="switch-user_btn" size="small" variant="outlined" icon color="tertiary">
        <v-icon icon="fas fa-check" />
      </v-btn>
    </div>
    <v-divider></v-divider>
  </div>
</template>

<style scoped lang="scss">
.user-line {
  &.active {
    background-color: rgba(60, 126, 183, 0.05);
  }
}
</style>
